export const useEventBus = () => {

	return {
		on(event: any, callback: any) {
			document.addEventListener(`Wooptima.${event}`, (e: any) => callback(e.detail));
		},
		dispatch(event: any, data: any) {
			document.dispatchEvent(new CustomEvent(`Wooptima.${event}`, { detail: {...data} }));
		},
		remove(event: any, callback: any|undefined = undefined) {
			document.removeEventListener(`Wooptima.${event}`, callback);
		},
	};
}

export default useEventBus;